import { render, staticRenderFns } from "./MinimalNavigationElement.vue?vue&type=template&id=30cb694d&scoped=true&"
import script from "./MinimalNavigationElement.vue?vue&type=script&lang=js&"
export * from "./MinimalNavigationElement.vue?vue&type=script&lang=js&"
import style0 from "./MinimalNavigationElement.vue?vue&type=style&index=0&id=30cb694d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb694d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30cb694d')) {
      api.createRecord('30cb694d', component.options)
    } else {
      api.reload('30cb694d', component.options)
    }
    module.hot.accept("./MinimalNavigationElement.vue?vue&type=template&id=30cb694d&scoped=true&", function () {
      api.rerender('30cb694d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/MinimalNavigationElement.vue"
export default component.exports